import React from 'react';
import { FermataMark } from './FermataMark';
import { Button } from './Button';
export function Cta() {
  return <section id="contact" className="bg-ink text-paper-on text-center" data-id="element-12">
      <div className="max-w-page mx-auto px-6" data-id="element-13">
        <div className="py-[64px] pb-[70px] max-w-[680px] mx-auto" data-id="element-14">
          <div className="flex justify-center mb-6" data-id="element-15">
            <FermataMark variant="breath" data-id="element-16" />
          </div>

          <h2 className="font-display font-medium text-[clamp(1.9rem,3.6vw,2.6rem)] leading-[1.12] m-0 mb-4 tracking-[-0.01em]" data-id="element-17">
            Meet Chime — and try it for 30 days.
          </h2>

          <p className="text-[rgba(251,250,247,0.72)] text-[1.05rem] max-w-[46ch] mx-auto m-0 mb-[30px]" data-id="element-18">
            Wear it in your actual hard moments. If it doesn't earn its place,
            send it back within 30 days for a full refund — return label on us.
          </p>

          <Button href="https://www.wearchime.com/products/chime" variant="onink" size="lg" data-id="element-19">
            Choose your Chime
          </Button>

          
        </div>
      </div>
    </section>;
}